export const initialTableDataValue = {
    rows: [],
    count: 0,
};